import React, { Component, createRef, lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Breadcrumb, Button, Col, Container, Form, FormGroup, Row, Image } from 'react-bootstrap';
import BottomSide from '../../components/BottomSide';
import { RiImageAddFill } from "react-icons/ri";
import { RiDeleteBin5Line } from "react-icons/ri";
import { storage } from '../../../config/fbConfig';
import './cropperStyles.css';
import { ref, uploadBytes } from 'firebase/storage';
import CircularProgress from '../../../components/common/CircularProgress';
import { generateImageName } from '../../../utils/canvasUtils';
import { createProject } from '../../../store/actions/projectActions';
import AdminPanelMenuBar from '../../Admin/AdminPanelMenuBar';
import ProjectLogoSelectModal from './ProjectLogoSelectModal';
import { MdOutlineAddBox } from "react-icons/md";
import ProjectPartnerComponent from './ProjectPartnerComponent';
import PartnerSelectModal from './PartnerSelectModal';
import { Helmet } from 'react-helmet';
import { owners, projectStatuses } from '../../../Consts';

const CKEditorComponent = lazy(() => import('../../../components/common/CKEditorComponent'));

class AddProjectPage extends Component {

    constructor(props) {
        super(props);
        this.fileInputRef = createRef();
    }

    state = {
        accFacebook: '',
        accInstagram: '',
        accWebSite: '',
        budget: '',
        description: '',
        endDate: '',
        keyAction: '',
        owner: '',
        partners: [],
        projectLogo: '',
        projectType: '',
        referanceNumber: '',
        startDate: '',
        title: '',
        topics: '',
        projectStatus: '',
        projectId: '',

        errorMessage: null,
        croppedImage: null,
        croppedImageThumb: null,
        showImageSelectModal: false,
        showPartnerSelectModal: false,
        isSubmitting: false
    };

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        })
    }

    handleEditorChange = (data) => {
        this.setState({ description: data });
    }

    handleSubmit = async (e) => {

        const { croppedImage, croppedImageThumb } = this.state;

        if (this.state.description === '') {
            this.setState({ errorMessage: "Project description required" });
            e.preventDefault();
        }
        else {
            e.preventDefault();

            this.setState({ isSubmitting: true });

            try {
                if (croppedImage) {
                    const promises = [];

                    const logoName = generateImageName(croppedImage.type)
                    this.setState({ projectLogo: logoName });

                    //featured ipage uploading
                    const storageRef = ref(storage, "projects/" + logoName);
                    promises.push(uploadBytes(storageRef, croppedImage));
                    //featured image thumb uploading
                    const storageRefThumb = ref(storage, "projects/thumb_" + logoName);
                    promises.push(uploadBytes(storageRefThumb, croppedImageThumb));

                    await Promise.all(promises);
                }

                const projectItem = {
                    title: this.state.title,
                    description: this.state.description,
                    projectLogo: this.state.projectLogo,
                    accFacebook: this.state.accFacebook,
                    accInstagram: this.state.accInstagram,
                    accWebSite: this.state.accWebSite,
                    budget: this.state.budget,
                    endDate: this.state.endDate,
                    keyAction: this.state.keyAction,
                    owner: this.state.owner,
                    partners: this.state.partners,
                    projectType: this.state.projectType,
                    referanceNumber: this.state.referanceNumber,
                    startDate: this.state.startDate,
                    topics: this.state.topics,
                    projectStatus: this.state.projectStatus,
                }

                this.props.createProject(projectItem, this.state.projectId);
                this.props.history.push('/manage_projects')

            } catch (error) {
                console.error(error)
            } finally {
                this.setState({ isSubmitting: false });
            }

        }
    }

    handleShowImageSelectModal = () => { this.setState({ showImageSelectModal: true }) }
    handleCloseImageSelectModal = () => { this.setState({ showImageSelectModal: false }) }

    handleDeleteProjectImage = () => {
        this.setState({
            projectLogo: '',
            croppedImage: '',
            croppedImageThumb: ''
        });
    }
    handleShowPartnerSelectModal = () => { this.setState({ showPartnerSelectModal: true }) }
    handleClosePartnerSelectModal = () => { this.setState({ showPartnerSelectModal: false }) }

    handleAddPartner = (formValues) => {
        this.setState((prevState) => ({
            partners: [...prevState.partners, formValues]
        }));
    };

    handlePartnerDelete = (partnerToDelete) => {
        this.setState((prevState) => ({
            partners: prevState.partners.filter(partner => partner !== partnerToDelete)
        }));
    };

    render() {

        const { auth } = this.props;
        const { title, projectId, description, errorMessage, partners,
            topics, referanceNumber, startDate, endDate, projectType,
            keyAction, budget, accFacebook, accInstagram, accWebSite, owner, projectStatus,
        } = this.state;


        return (
            <div>
                <Helmet>
                    <title>Add Project - Bright Youth Community</title>
                </Helmet>

                <AdminPanelMenuBar />

                <Container className="mt-4">
                    <Breadcrumb>
                        <Breadcrumb.Item href="/admin">Admin Panel</Breadcrumb.Item>
                        <Breadcrumb.Item href="/manage_projects">Manage Projects</Breadcrumb.Item>
                        <Breadcrumb.Item active>Add Project</Breadcrumb.Item>
                    </Breadcrumb>
                </Container>

                <Container>
                    <h1>Add Project</h1>
                    <Form onSubmit={this.handleSubmit} className='bg-light'>

                        <div className='m-5'>

                            <br />
                            <Form.Group>

                                <Form.Label><strong>Project Logo</strong></Form.Label>

                                <div className="d-flex flex-row flex-wrap">
                                    <div>

                                        <Image
                                            id="projectLogo"
                                            src={this.state.croppedImage ? URL.createObjectURL(this.state.croppedImage) : "/imgs/project-logo-placeholder.png"}
                                            thumbnail
                                            width={180}
                                            height={180}
                                        />
                                    </div>

                                    <div className='ms-2'>
                                        <RiImageAddFill size={36} color='blue' cursor="pointer" onClick={this.handleShowImageSelectModal} />
                                        <br />
                                        {this.state.croppedImage &&
                                            <RiDeleteBin5Line size={36} color='blue' cursor="pointer" onClick={() => this.handleDeleteProjectImage()} />
                                        }
                                    </div>

                                </div>

                                <Container>

                                    <ProjectLogoSelectModal
                                        show={this.state.showImageSelectModal} // Modalın açık/kapalı durumunu geçirin
                                        handleClose={this.handleCloseImageSelectModal} // Modalı kapatan işlevi geçirin
                                        handleCallback={(croppedImage, croppedImageThumb, imageName) => {
                                            this.setState({
                                                projectLogo: imageName,
                                                croppedImage: croppedImage,
                                                croppedImageThumb: croppedImageThumb
                                            });
                                        }}
                                    />

                                </Container>
                            </Form.Group>
                            <br />

                            <FormGroup>
                                <Form.Label><strong>Project No *</strong></Form.Label>
                                <Form.Control
                                    id="projectId"
                                    type="text"
                                    placeholder="Enter project no (e.g. 004)"
                                    maxLength='3'
                                    value={projectId}
                                    onChange={this.handleChange}
                                    required
                                />
                            </FormGroup>
                            <br />

                            <FormGroup>
                                <Form.Label><strong>Project Name *</strong></Form.Label>
                                <Form.Control
                                    id="title"
                                    type="text"
                                    placeholder="Enter project name"
                                    maxLength='300'
                                    value={title}
                                    onChange={this.handleChange}
                                    required
                                />
                            </FormGroup>
                            <br />

                            <FormGroup>
                                <Form.Label><strong>Project Referance Number *</strong></Form.Label>
                                <Form.Control
                                    id="referanceNumber"
                                    type="text"
                                    placeholder="Enter project legal referance number"
                                    maxLength='150'
                                    value={referanceNumber}
                                    onChange={this.handleChange}
                                    required
                                />
                            </FormGroup>
                            <br />

                            <FormGroup>
                                <Form.Label><strong>Project Start Date *</strong></Form.Label>
                                <Form.Control
                                    id="startDate"
                                    type="text"
                                    placeholder="Enter start date (dd.mm.yyyy)"
                                    maxLength='10'
                                    value={startDate}
                                    onChange={this.handleChange}
                                    required
                                />
                            </FormGroup>
                            <br />

                            <FormGroup>
                                <Form.Label><strong>Project End Date *</strong></Form.Label>
                                <Form.Control
                                    id="endDate"
                                    type="text"
                                    placeholder="Enter end date (dd.mm.yyyy)"
                                    maxLength='10'
                                    value={endDate}
                                    onChange={this.handleChange}
                                    required
                                />
                            </FormGroup>
                            <br />

                            <FormGroup>
                                <Form.Label><strong>Project Type *</strong></Form.Label>
                                <Form.Control
                                    id="projectType"
                                    type="text"
                                    placeholder="Enter project type"
                                    maxLength='100'
                                    value={projectType}
                                    onChange={this.handleChange}
                                    required
                                />
                            </FormGroup>
                            <br />

                            <FormGroup>
                                <Form.Label><strong>Key Action</strong></Form.Label>
                                <Form.Control
                                    id="keyAction"
                                    type="text"
                                    placeholder="Enter key action"
                                    maxLength='100'
                                    value={keyAction}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <br />

                            <FormGroup>
                                <Form.Label><strong>Project Budget</strong></Form.Label>
                                <Form.Control
                                    id="budget"
                                    type="text"
                                    placeholder="Enter project budget"
                                    maxLength='12'
                                    value={budget}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <br />

                            <FormGroup>
                                <Form.Label><strong>Project Facebook Account</strong></Form.Label>
                                <Form.Control
                                    id="accFacebook"
                                    type="text"
                                    placeholder="Enter URL (https://)"
                                    value={accFacebook}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <br />

                            <FormGroup>
                                <Form.Label><strong>Project Instagram Account</strong></Form.Label>
                                <Form.Control
                                    id="accInstagram"
                                    type="text"
                                    placeholder="Enter URL (https://)"
                                    value={accInstagram}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <br />

                            <FormGroup>
                                <Form.Label><strong>Project Website</strong></Form.Label>
                                <Form.Control
                                    id="accWebSite"
                                    type="text"
                                    placeholder="Enter URL (https://)"
                                    value={accWebSite}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <br />


                            <FormGroup>
                                <Form.Label><strong>Project Description *</strong></Form.Label>
                                <Suspense fallback={<div>Loading...</div>}>
                                    <CKEditorComponent
                                        data={description}
                                        onChange={this.handleEditorChange}
                                        required
                                    />
                                </Suspense>

                            </FormGroup>
                            <br />

                            <FormGroup>
                                <Form.Label><strong>Topics *</strong></Form.Label>
                                <Form.Control
                                    id="topics"
                                    type="text"
                                    placeholder="Enter project topics. Use comma after each topics"
                                    maxLength='300'
                                    value={topics}
                                    onChange={this.handleChange}
                                    required
                                />
                            </FormGroup>
                            <br />

                            <FormGroup>
                                <Form.Label><strong>Project Owner *</strong></Form.Label>
                                <Form.Select
                                    id="owner"
                                    aria-label="Select Owner"
                                    value={owner}
                                    onChange={this.handleChange} // Handle select change
                                    required
                                >
                                    <option value="">Please select an item</option>
                                    {owners.map((owner, index) => (
                                        <option key={index} value={index}>{owner}</option>
                                    ))}
                                </Form.Select>
                            </FormGroup>
                            <br />

                            <FormGroup>
                                <Form.Label><strong>Project Status *</strong></Form.Label>
                                <Form.Select
                                    id="projectStatus"
                                    aria-label="Select Project Status"
                                    value={projectStatus}
                                    onChange={this.handleChange} // Handle select change
                                    required
                                >
                                    <option value="">Please select an item</option>
                                    {projectStatuses.map((pStatus, index) => (
                                        <option key={index} value={index}>{pStatus}</option>
                                    ))}
                                </Form.Select>
                            </FormGroup>
                            <br />

                            <FormGroup>
                                <Form.Label><strong>Project Partners</strong></Form.Label>

                                <div className="d-flex flex-row flex-wrap">
                                    <div style={{
                                        position: 'flex', width: '90px', height: '90px', display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        border: '1px solid blue'
                                    }} >
                                        <MdOutlineAddBox size={48} color='blue' cursor="pointer" onClick={this.handleShowPartnerSelectModal} />
                                    </div>

                                    {
                                        partners.map((partner, index) => (
                                            <div key={index}>
                                                <ProjectPartnerComponent
                                                    partner={partner}
                                                    handleDelete={this.handlePartnerDelete}
                                                />
                                            </div>
                                        ))
                                    }



                                </div>

                            </FormGroup>
                            <br />

                            {errorMessage && <p className="text-danger">{errorMessage}</p>}

                            {this.state.isSubmitting ?
                                (
                                    <CircularProgress />

                                ) :
                                (
                                    <Row className='align-center'>
                                        <Col>
                                            <Button variant="primary" type="submit">
                                                Add
                                            </Button>
                                        </Col>
                                    </Row>

                                )
                            }

                            <br />
                        </div>

                    </Form>
                </Container>
                <PartnerSelectModal
                    show={this.state.showPartnerSelectModal} // Modalın açık/kapalı durumunu geçirin
                    handleClose={this.handleClosePartnerSelectModal} // Modalı kapatan işlevi geçirin
                    handleCallback={this.handleAddPartner}
                />

                <BottomSide />
            </div>

        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.firebase.auth,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        createProject: (pItem, recordId) => dispatch(createProject(pItem, recordId))
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps)
)(AddProjectPage);